import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";
import PersonalInformationPage from "./personalInformationPage";
import UpdatePersonalInformation from "./updatePersonalInformation";
import "./personalInformation.scss";

const PersonalInformation: FC = () => {
  return (
    <Routes>
      <Route path="/update" element={<UpdatePersonalInformation />} />
      <Route index element={<PersonalInformationPage />} />
    </Routes>
  );
};

export default PersonalInformation;
